// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___317a5f1290dea8c212b","cls2":"CreateSocialItem-cls2___180ee9af174485067ea CreateSocialItem-cls1___317a5f1290dea8c212b"};